require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-yoga-will-never-be-the-same-again.json") })
        }
      }, "path---blog-yoga-will-never-be-the-same-again");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-yoga-will-never-be-the-same-again!./.cache/json/blog-yoga-will-never-be-the-same-again.json
// module id = 503
// module chunks = 231608221292675